import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

const DEFAULT_LABEL = 'Este producto';

export const FeaturedProductCardWrapper: FC<{ children: ReactNode; label?: string }> = ({
	children,
	label = DEFAULT_LABEL,
}) => (
	<Box
		sx={{
			position: 'relative',
			'& .product-card-container': {
				width: { xs: '210px', sm: '328px' },
				height: { xs: '380px', sm: '510px' },
			},
			'& .product-card-frame': {
				height: { xs: '210px', sm: '328px' },
			},
			'& .product-card-image': {
				width: { xs: '210px', sm: '328px' },
				height: { xs: '210px', sm: '328px' },
			},
			'& .product-card-frame::after': {
				content: JSON.stringify(label),
				position: 'absolute',
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 2,
				backgroundColor: '#050000',
				color: '#FFFFFF',
				fontSize: { xs: '15px', sm: '17px' },
				fontWeight: 500,
				textAlign: 'center',
				padding: '6px 0',
				letterSpacing: '0.2px',
				pointerEvents: 'none',
			},
		}}
	>
		{children}
	</Box>
);
